import React from 'react'
import ReactPaginate, { ReactPaginateProps } from 'react-paginate'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import styles from './Pagination.module.scss'
import classNames from 'classnames'

const Pagination: React.FC<ReactPaginateProps> = ({
  nextLabel,
  previousLabel,
  pageCount,
  onPageChange,
  ...props
}) => {
  return (
    <ReactPaginate
      breakLabel="..."
      pageCount={pageCount}
      nextLabel={nextLabel || <AiOutlineRight />}
      previousLabel={previousLabel || <AiOutlineLeft />}
      pageRangeDisplayed={3}
      onPageChange={onPageChange}
      containerClassName={styles.paginationContainer}
      pageClassName={styles.paginationItem}
      activeClassName={classNames(styles.paginationItem, styles.active)}
      breakClassName={styles.paginationItem}
      previousClassName={styles.paginationItem}
      nextClassName={styles.paginationItem}
      {...props}
    />
  )
}

export default Pagination
